const constants = {
	database_name: "scientia-eu-v4-api-d4-01",
	millisecondsToHours: 1 / (1000 * 60 * 60),
	minutesToHours: 1 / 60,
	curTimezone: "Europe/Dublin",
};

export default constants;
